import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "style__Container",
  componentId: "sc-4ssbsv-0"
})(["margin-bottom:50px;"]);